import React, { Suspense, useState } from "react";

import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component

import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
// import { useDeleteData, useFetchData } from "hooks/useApiHooks";
// import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
// import { useDeleteHandler } from "hooks/useDeleteHandler";
// import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { useLabel } from "contexts/v1/masterData/LabelContext";
import { LabelCreateProvider } from "contexts/v1/masterData/LabelCreateContext";
import Swal from "sweetalert2";
import { deleteRequest } from "services/api";

// Main labels Page Component
const LabelsPage = () => {
  const { labels, refetch, Pagination } = useLabel();
  console.log("labels", labels);
  // console.log("LabelsPage refetch", refetch);
  const [currentPage, setCurrentPage] = useState(1); // For pagination

  const { handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Label",
      <LabelCreateProvider>
        <CreatePage
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Label created successfully");
            handleSuccessToast(true, "Label created");
            refetch();
          }}
          onError={handleError}
        />
      </LabelCreateProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Label",
      <LabelCreateProvider>
        <CreatePage
          initialData={data}
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Label updated successfully");
            handleSuccessToast(true, "Label updateding");
            refetch();
          }}
          onError={handleError}
        />
      </LabelCreateProvider>
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/label/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Label deleteing");
          refetch();
        }
      }
    });
  };

  const totalPages = labels.pagination?.last_page || 1;

  // const PaginationOld = usePaginationWithComponent({
  //   totalPages,
  //   currentPage,
  //   onPageChange: setCurrentPage,
  //   visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  // });

  if (labels.loading) return <FullLoader />;
  if (labels.error) return <Suspense error={labels.error} />;

  return (
    <LayoutDashboard>
      {/* Your content here */}
      <div className="container-fluid mt-5">
        <div className="table-container">
          <h2>Labels</h2>
          <div className="search-container mb-3">
            {/* Search input */}
            <SearchInput />

            {/* Create button */}
            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          {/* Table */}
          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Label Name</th>
                  <th>Color</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {labels.data.length > 0 && (
                <tbody>
                  {labels.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>
                          <div
                            className="d-flex align-items-center"
                            style={{
                              backgroundColor: data.color || "#fff", // Display the color
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%", // Circle shape for color
                            }}
                          ></div>
                        </td>
                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              {/* history */}
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default LabelsPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useLabel();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
